module.exports = __webpack_public_path__ + "media/images/icons/flags/VI-62a6ea4c6d6577c524da05dcc50e81d6.svg";